import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { handleLocalData } from "../store/actions";
import { useData, useDispatch } from "../store/DataProvider";
import AdminOptions from "./admin/AdminOptions";
import { isTestEnvironment } from "../services/environment";

const Header = ({ type }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const dispatch = useDispatch();
    const {
        user: { isSuperAdmin },
        adminArea,
    } = useData();
    const cookies = new Cookies(null, { path: "/" });

    const onClickLogout = e => {
        e.preventDefault();
        cookies.remove("auth", { path: "/" });
        handleLocalData(
            [
                { type: "logout", payload: true },
                { type: "user", payload: {} },
            ],
            dispatch,
        );
        navigate("/auth");
    };

    const onClickNav = (e, path) => {
        e.preventDefault();
        navigate(path);
    };

    const getAdminLink = () => {
        if (!isSuperAdmin) {
            return null;
        }
        const path = pathname === "/admin" ? "/" : "/admin";
        const label = pathname === "/admin" ? "home" : "admin";
        return (
            <h2 className="header-link" onClick={e => onClickNav(e, path)}>
                {label}
            </h2>
        );
    };

    const getLogoutLink = () => {
        if (pathname === "/admin") {
            return null;
        }
        return (
            <h2 className="header-link" onClick={onClickLogout}>
                logout
            </h2>
        );
    };

    const isTest = isTestEnvironment();

    return (
        <div className={isTest ? "header header-test" : "header"}>
            <div className="header-wrapper">
                {/* the left buffer is otherwise an empty spacer, and is the one
                    place a marker fits on every screen -- the admin screens
                    give the middle over to the section nav */}
                <div className="header-buffer">
                    {isTest ? (
                        <span className="header-test-flag">
                            {/* the long form where there is room for it; on a
                                phone the admin nav needs the width back */}
                            <span className="header-test-long">
                                testing only
                            </span>
                            <span className="header-test-short">test</span>
                        </span>
                    ) : null}
                </div>
                {type === "admin" ? (
                    <AdminOptions adminArea={adminArea} />
                ) : (
                    <h2 className="header-text">
                        {isTest ? (
                            <>
                                {/* the full phrase does not fit a phone beside
                                    the nav links; the short form keeps the name
                                    that matters and the flag says the rest */}
                                <span className="header-test-long">
                                    Namjing Mai Jing - testing only
                                </span>
                                <span className="header-test-short">
                                    Namjing Mai Jing
                                </span>
                            </>
                        ) : (
                            "namjing beautiful hair salon"
                        )}
                    </h2>
                )}
                <div className="header-buffer">
                    {getLogoutLink()}
                    {getAdminLink()}
                </div>
            </div>
        </div>
    );
};

export default Header;
